document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('#op-menu-toggle');
  const menu = document.querySelector('#op-mobile-menu');
  if (button && menu) {
    button.addEventListener('click', () => {
      const open = menu.classList.toggle('open');
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  document.querySelectorAll('[data-op-menu-toggle]').forEach((toggle) => {
    const header = toggle.closest('.op-header');
    const mobileMenu = header && header.querySelector('[data-op-mobile-menu]');
    if (!mobileMenu) return;
    toggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const price = option && option.dataset.price;
      const product = select.closest('.op-product__details');
      const priceNode = product && product.querySelector('[data-product-price]');
      if (price && priceNode) priceNode.textContent = price;
      const compareNode = product && product.querySelector('[data-product-compare]');
      if (compareNode) {
        compareNode.textContent = option.dataset.compare || '';
        compareNode.hidden = !option.dataset.compare;
      }
      const skuNode = product && product.querySelector('[data-product-sku]');
      if (skuNode) skuNode.textContent = option.dataset.sku || '—';
      const addButton = product && product.querySelector('[data-add-to-cart]');
      if (addButton) {
        const available = option.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart →' : 'Sold out';
      }
    });
  });

  document.querySelectorAll('.op-quantity__control').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  const mediaButtons = Array.from(document.querySelectorAll('[data-product-media]'));
  if (mediaButtons.length) {
    const dialog = document.createElement('dialog');
    dialog.className = 'op-media-dialog';
    dialog.setAttribute('aria-label', 'Enlarged product image');
    const control = (label, className, text) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.setAttribute('aria-label', label);
      button.textContent = text;
      return button;
    };
    const close = control('Close enlarged image', 'op-media-dialog__close', 'Close ×');
    const zoomControl = control('Zoom in image', 'op-media-dialog__zoom', 'Zoom in +');
    const previous = control('Previous image', 'op-media-dialog__arrow op-media-dialog__arrow--previous', '‹');
    const next = control('Next image', 'op-media-dialog__arrow op-media-dialog__arrow--next', '›');
    previous.hidden = next.hidden = mediaButtons.length < 2;
    const stage = document.createElement('div');
    stage.className = 'op-media-dialog__stage';
    const zoomImage = control('Zoom in image', 'op-media-dialog__image-button', '');
    const image = document.createElement('img');
    image.draggable = false;
    zoomImage.append(image);
    stage.append(zoomImage);
    const counter = document.createElement('p');
    counter.className = 'op-media-dialog__counter';
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');
    dialog.append(stage, previous, next, counter, zoomControl, close);
    document.body.append(dialog);
    let activeIndex = 0;
    let zoomed = false;
    const setZoom = (value) => {
      zoomed = value;
      stage.classList.toggle('is-zoomed', value);
      const label = value ? 'Zoom out image' : 'Zoom in image';
      zoomImage.setAttribute('aria-label', label);
      zoomImage.setAttribute('aria-pressed', String(value));
      zoomControl.setAttribute('aria-label', label);
      zoomControl.setAttribute('aria-pressed', String(value));
      zoomControl.textContent = value ? 'Zoom out −' : 'Zoom in +';
      stage.scrollLeft = value ? (stage.scrollWidth - stage.clientWidth) / 2 : 0;
      stage.scrollTop = value ? (stage.scrollHeight - stage.clientHeight) / 2 : 0;
    };
    const showImage = (index) => {
      activeIndex = (index + mediaButtons.length) % mediaButtons.length;
      const button = mediaButtons[activeIndex];
      setZoom(false);
      image.src = button.dataset.mediaSrc;
      image.alt = button.querySelector('img')?.alt || 'Product image';
      counter.textContent = (activeIndex + 1) + ' / ' + mediaButtons.length;
    };
    mediaButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        if (!button.dataset.mediaSrc) return;
        showImage(index);
        dialog.showModal();
      });
    });
    zoomImage.addEventListener('click', () => setZoom(!zoomed));
    zoomControl.addEventListener('click', () => setZoom(!zoomed));
    previous.addEventListener('click', () => showImage(activeIndex - 1));
    next.addEventListener('click', () => showImage(activeIndex + 1));
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => setZoom(false));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
  }

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('sort_by')) select.value = params.get('sort_by');
    select.addEventListener('change', () => {
      params.set('sort_by', select.value);
      window.location.search = params.toString();
    });
  });
});
